import { render, staticRenderFns } from "./BrouillonToolbarWiki.vue?vue&type=template&id=de243d2c&scoped=true"
import script from "./BrouillonToolbarWiki.vue?vue&type=script&lang=js"
export * from "./BrouillonToolbarWiki.vue?vue&type=script&lang=js"
import style0 from "./BrouillonToolbarWiki.vue?vue&type=style&index=0&id=de243d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de243d2c",
  null
  
)

export default component.exports